// @ts-nocheck

  import CarryOutOutlined from '@ant-design/icons/es/icons/CarryOutOutlined';
import CalculatorOutlined from '@ant-design/icons/es/icons/CalculatorOutlined';
import IdcardOutlined from '@ant-design/icons/es/icons/IdcardOutlined';
import MediumOutlined from '@ant-design/icons/es/icons/MediumOutlined';
import SwitcherOutlined from '@ant-design/icons/es/icons/SwitcherOutlined';
import CodeOutlined from '@ant-design/icons/es/icons/CodeOutlined';
import DollarOutlined from '@ant-design/icons/es/icons/DollarOutlined';
import FormOutlined from '@ant-design/icons/es/icons/FormOutlined';
import DiffOutlined from '@ant-design/icons/es/icons/DiffOutlined';
import ScheduleOutlined from '@ant-design/icons/es/icons/ScheduleOutlined';
import BarChartOutlined from '@ant-design/icons/es/icons/BarChartOutlined';
import AreaChartOutlined from '@ant-design/icons/es/icons/AreaChartOutlined';
import LineChartOutlined from '@ant-design/icons/es/icons/LineChartOutlined';
import BarsOutlined from '@ant-design/icons/es/icons/BarsOutlined';
import CreditCardOutlined from '@ant-design/icons/es/icons/CreditCardOutlined';
import PayCircleOutlined from '@ant-design/icons/es/icons/PayCircleOutlined';
import SettingOutlined from '@ant-design/icons/es/icons/SettingOutlined';
import FileTextOutlined from '@ant-design/icons/es/icons/FileTextOutlined';
import AimOutlined from '@ant-design/icons/es/icons/AimOutlined'
  export default {
    CarryOutOutlined,
CalculatorOutlined,
IdcardOutlined,
MediumOutlined,
SwitcherOutlined,
CodeOutlined,
DollarOutlined,
FormOutlined,
DiffOutlined,
ScheduleOutlined,
BarChartOutlined,
AreaChartOutlined,
LineChartOutlined,
BarsOutlined,
CreditCardOutlined,
PayCircleOutlined,
SettingOutlined,
FileTextOutlined,
AimOutlined
  }